"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AltiumLabelTypeNameGeneratorSchema = exports.AltiumLabelTypesSchema = exports.AltiumCombobulationDimensions = void 0;
exports.nameAltiumBusDimension = nameAltiumBusDimension;
const zod_1 = require("zod");
var AltiumCombobulationDimensions;
(function (AltiumCombobulationDimensions) {
    AltiumCombobulationDimensions["Wire"] = "wire";
    AltiumCombobulationDimensions["Bus"] = "bus";
    AltiumCombobulationDimensions["SignalHarness"] = "altium-harness";
})(AltiumCombobulationDimensions || (exports.AltiumCombobulationDimensions = AltiumCombobulationDimensions = {}));
function nameAltiumBusDimension(busName, busMemberName) {
    return `${busName}:${busMemberName}`;
}
exports.AltiumLabelTypesSchema = zod_1.default.enum([
    'net-label',
    'power-port',
    'off-sheet-connector',
    'port',
    'sheet-entry',
]);
exports.AltiumLabelTypeNameGeneratorSchema = zod_1.default.enum([
    'net-label',
    'power-port',
    'off-sheet-connector',
    'port',
    'sheet-entry',
    'ComponentConnection',
    'NamingPin',
]);
//# sourceMappingURL=AltiumLabelTypes.js.map